import type { Audience, ClinicAddress, ClinicSignatureMode } from './api'

/** Rótulos do cadastro da clínica: o valor do contrato nunca vai cru para a tela (T21). */

export const AUDIENCES: Audience[] = ['patient', 'student', 'employee', 'third_party']

export const AUDIENCE_LABELS: Record<Audience, string> = {
  patient: 'Pacientes',
  student: 'Alunos',
  employee: 'Funcionários',
  third_party: 'Terceiros',
}

/** "Pacientes · Alunos", na ordem do contrato. */
export function audiencesLabel(audiences: Audience[]) {
  return AUDIENCES.filter((audience) => audiences.includes(audience))
    .map((audience) => AUDIENCE_LABELS[audience])
    .join(' · ')
}

export const SIGNATURE_MODE_LABELS: Record<ClinicSignatureMode, string> = {
  manual: 'A responsável assina cada documento',
  automatic: 'Assinatura automática',
}

/**
 * Os fusos do Brasil que a API aceita (RT-21; a lista é a de `timezone` no contrato de
 * `PUT /admin/clinic-profile`), com o horário e a cidade de referência.
 */
export const TIMEZONES: { value: string; label: string }[] = [
  { value: 'America/Sao_Paulo', label: 'Horário de Brasília · São Paulo' },
  { value: 'America/Bahia', label: 'Horário de Brasília · Salvador' },
  { value: 'America/Fortaleza', label: 'Horário de Brasília · Fortaleza' },
  { value: 'America/Recife', label: 'Horário de Brasília · Recife' },
  { value: 'America/Maceio', label: 'Horário de Brasília · Maceió' },
  { value: 'America/Belem', label: 'Horário de Brasília · Belém' },
  { value: 'America/Araguaina', label: 'Horário de Brasília · Palmas' },
  { value: 'America/Santarem', label: 'Horário de Brasília · Santarém' },
  { value: 'America/Manaus', label: 'Horário do Amazonas · Manaus' },
  { value: 'America/Cuiaba', label: 'Horário do Amazonas · Cuiabá' },
  { value: 'America/Campo_Grande', label: 'Horário do Amazonas · Campo Grande' },
  { value: 'America/Porto_Velho', label: 'Horário do Amazonas · Porto Velho' },
  { value: 'America/Boa_Vista', label: 'Horário do Amazonas · Boa Vista' },
  { value: 'America/Rio_Branco', label: 'Horário do Acre · Rio Branco' },
  { value: 'America/Noronha', label: 'Horário de Fernando de Noronha' },
]

export const DEFAULT_TIMEZONE = 'America/Sao_Paulo'

/** As 27 unidades da federação, na ordem alfabética da sigla. */
export const STATES = [
  'AC',
  'AL',
  'AM',
  'AP',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MG',
  'MS',
  'MT',
  'PA',
  'PB',
  'PE',
  'PI',
  'PR',
  'RJ',
  'RN',
  'RO',
  'RR',
  'RS',
  'SC',
  'SE',
  'SP',
  'TO',
]

/** "Avenida Paulista, 1000 · Conjunto 42 · Bela Vista · São Paulo/SP", para a leitura. */
export function addressLine(address: ClinicAddress | null) {
  if (!address) return 'Endereço não informado'
  return [
    `${address.street}, ${address.number}`,
    address.complement,
    address.district,
    `${address.city}/${address.state}`,
  ]
    .filter(Boolean)
    .join(' · ')
}
